// extracted by mini-css-extract-plugin
export var dropdown = "_gp-0";
export var imagePlaceholder = "_gp-2";
export var imageWrapper = "_gp-3";
export var productImage = "_gp-1";
export var truncateContainer = "_gp-4";
export var truncateText = "_gp-5";